import { Injectable, Output, EventEmitter } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { HttpService } from './../services/http.service';
import { Globals } from '../models/globals.model';

@Injectable({
  providedIn: 'root'
})
export class TagMasterService {

  apiUri: string;
  graphUri: string;

  locationApi = "TagMaster/GetLocations";
  unitApi = "TagMaster/GetUnits";
  equipmentApi = "TagMaster/GetEquipments";
  tagTypeApi = "TagMaster/GetTagTypes";
  tagListApi = "TagMaster/GetTagsList";
  tagDetailsApi = "TagMaster/GetTagDetails";
  tagCreateApi = "TagMaster/CreateTag";
  tagUpdateApi = "TagMaster/UpdateTag";
  tagIdApi = "tagmaster/GetTagIds";
  useCaseApi = "TagMaster/GetUseCases";
  useCaseByMasterTagIdApi = "tagmaster/GetUseCasesByTagMasterId";
  piPointApi = "TagMaster/GetPiPointData";
  tagExistInPiPApi = "TagMaster/TagExistsInPiPoint";
  moveTagAcrossPlatformApi = "ADF/TagMasterSync";
  tokenApi = "TagMaster/getToken";

  locationForFilter: any;
  unitForFilter: any;
  unitList: any;
  equipmentList: any;
  useCaseList: any;
  eqForFilter: any;
  tagIdForFilter: any;
  ucForFilter: any;

  constructor(private readonly httpService: HttpService, private readonly globals: Globals, private readonly http: HttpClient) {
    this.apiUri = this.globals.config.foundationPlatformApi_client_resourceUri;
    this.graphUri = this.globals.config.graphApi_client_resourceUri;
  }

  tagsMovement(tagToMove) {
    return this.http.post<any>(this.apiUri + this.moveTagAcrossPlatformApi, tagToMove);
  }

  getLocations() {
    return this.http.get(this.apiUri + this.locationApi);
  }
  getToken() {
    return this.http.get(this.apiUri + this.tokenApi);
  }
  getTagTypes() {
    return this.http.get(this.apiUri + this.tagTypeApi);
  }

  getUnits(selectedLoc) {
    let params = { locationId: selectedLoc };
    return this.http.get(this.apiUri + this.unitApi, {
      params: params
    });
  }


  getUseCases() {
    return this.http.get(this.apiUri + this.useCaseApi);
  }

  getUseCaseByMasterTagId(selectedMasterTagId) {
    let params = { tagMasterId: selectedMasterTagId };
    return this.http.get(this.apiUri + this.useCaseByMasterTagIdApi, {
      params: params
    });
  }

  filteredTagList(loc, uc, tagId) {
    
    if (uc == undefined || uc == null) {
      uc = 0;
    }
    if (loc == undefined || loc == null) {
      loc = 0;
    }
    let params = { tagId: tagId, locationId: loc, useCaseId : uc };
    return this.http.get(this.apiUri + this.tagListApi, {
      params: params
    });
  }

  addTag(tagMasterData) {
    return this.http.post<any>(this.apiUri + this.tagCreateApi, tagMasterData);
  }

  chktagExistInPiPoint(tagId) {
    let params = { tagid: tagId };
    return this.http.get(this.apiUri + this.tagExistInPiPApi, {
      params: params
    });
  }

  editTag(tagMasterData) {
    return this.http.post<any>(this.apiUri + this.tagUpdateApi, tagMasterData);
  }

  getTagDetails(tagId) {
    let params = { id: tagId };

    return this.http.get(this.apiUri + this.tagDetailsApi, {
      params: params
    });
  }

  getTagIds(loc, unit, eq, useCase) {
    let params = { locationId: loc, unitId: unit, equipmentId: eq, useCaseId: useCase };

    return this.http.get(this.apiUri + this.tagIdApi, {
      params: params
    });
  }

  sendNotification(data, globals, isNew) {
    let text;
    if (isNew == true) {
      text = "created";
    } else {
      text = "upated";
    }
    this.http.get("/api/appsettings/section/EmailService").subscribe((emailService: any): void => {
      let EmailNotificationUrl = emailService.EmailNotificationUrl;
      let cc = emailService.cc;
      //});
      let dataValue = { "MailHeader": { "From": "no-reply@total.com", "To": this.globals.userEmail, "Cc": cc, "Bcc": "", "Subject": "Tag notification" }, "Body": "Tag " + data.r4tagName + " has been " + text + ".", "AttachmentUrls": null };
      let formData = new FormData();
      formData.set('data', JSON.stringify(dataValue));
      let header = new HttpHeaders({});
      this.httpService.post(EmailNotificationUrl, formData, header).subscribe((response: any): void => {
        console.log(response);
      },
        error => {
          console.log("error:", error);
        });
    });


  }

  //getPiPoint() {
  //  return this.http.get(this.apiUri + this.piPointApi);
  //}

  getPiPoint(pageIndex, pageSize, sortColumn, sortDirection) {
    return this.http.get(this.apiUri + this.piPointApi + '?pageIndex=' + pageIndex + '&pageSize=' + pageSize +
      '&sortColumn=' + sortColumn + '&sortDirection=' + sortDirection);
  }

}
